module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/full-print/6-8723c484f37ca023dc14bf0c3dd8814e.jpg";